import Dropdown from 'react-dropdown'
import Tone from 'tone';
import {lfoTimeOptions, getLFOTimeOption} from './lfo-time-constants.js';
import redux from "operations/actions/updateStepRedux.js"
import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const LFOSyncedTimes = (props) => { 
    const onSelectLFOTime = (o) => {
        props.lfo.lfoRate = o.value();
    };
    return (
        <div className="lfo-rate-dropdown">
          <div className="lfo-rate-label">
            Rate:
          </div>
          <Dropdown
            className='osc-type-dropdown'
            controlClassName='osc-type-control-dropdown'
            arrowClassName='osc-type-arrow-dropdown'
            options={lfoTimeOptions}
            onChange={onSelectLFOTime}
            value={getLFOTimeOption(props.lfo.lfoRate)}
            placeholder="LFO" />
          <div className="clear-fix"/>
        </div>
    );
}

const mapStateToProps = (state, props) => {
    return {
        rate: props.lfo.lfoRate
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(LFOSyncedTimes);
